var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{style:({backgroundColor: _vm.currentColor})},[_c('div',{staticClass:"titleWrapper"},[_c('TitleSVG',{staticClass:"title-svg",class:{'invert' : this.invert},on:{"click":_vm.closeAll}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }